import React, { Suspense, useState } from 'react';
import TabSelection from '../TabSelection';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { DataCatalogueMessages } from '../../../core-utils/messages/DataCatalogueMessages';
import Loader from '../Loader';

// import DataCatalogueTab from '../DataCatalogueTab';
// import AggregateReportTab from '../AggregateReportTab';
// import DrugSavingProgramTab from '../DrugSavingProgramTab';

const DataCatalogueTab = React.lazy(() => import('../DataCatalogueTab'));
const AggregateReportTab = React.lazy(() => import('../AggregateReportTab'));
const DrugSavingProgramTab = React.lazy(
  () => import('../DrugSavingProgramTab'),
);
// const InvoicesTab = React.lazy(() => import('../InvoicesTab'));
// const CheckRegisterTab = React.lazy(() => import('../CheckRegisterTab'));
const OverviewTab = React.lazy(() => import('../OverviewTab'));

interface DataCatalogueTabsProps {}

type TabContentProps = {
  currentIndex: number;
};

const TabContent = ({ currentIndex }: TabContentProps) => {
  switch (currentIndex) {
    case 0:
      return <OverviewTab />;
    case 1:
      return <DataCatalogueTab tabName="medical" />;
    case 2:
      return <DataCatalogueTab tabName="rx" />;
    case 3:
      return <DataCatalogueTab tabName="census" />;
    case 4:
      return <AggregateReportTab />;
    // case 4:
    //   return <InvoicesTab />;
    // case 5:
    //   return <CheckRegisterTab />;
    case 5:
      return <DrugSavingProgramTab />;

    default:
      return <></>;
  }
};

const DataCatalogueTabs: React.FC<DataCatalogueTabsProps> = ({}) => {
  const {
    classes
  } = makeStyles()({
    root: {
      width: '100%',
    },
  })();
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const messages = DataCatalogueMessages;

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
  };

  return (
    <>
      <TabSelection
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={handleSelectedIndex}
        tabList={messages.TABS}
        margin="18px 0px"
      />
      <Grid className={classes.root}>
        <Suspense fallback={<Loader />}>
          <TabContent currentIndex={selectedTabIndex} />
        </Suspense>
      </Grid>
    </>
  );
};

export default DataCatalogueTabs;
